const REQUEST_TOTAL_APPROVED = 'platfi-ui-app/DASHBOARD/REQUEST_TOTAL_APPROVED';
const REQUEST_TOTAL_APPROVED_SUCCESS = 'platfi-ui-app/DASHBOARD/REQUEST_TOTAL_APPROVED_SUCCESS';
const REQUEST_TOTAL_APPROVED_FAILURE = 'platfi-ui-app/DASHBOARD/REQUEST_TOTAL_APPROVED_FAILURE';

export { REQUEST_TOTAL_APPROVED, REQUEST_TOTAL_APPROVED_SUCCESS, REQUEST_TOTAL_APPROVED_FAILURE };
